import React, { useState, useMemo, useRef, useEffect } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalGeneralSuccessfully from "screens/ModalGeneralSuccessfully";
import ModalAddChargeFailed from "screens/ModalAddChargeFailed";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { CREATE_CHARGE } from "graphql/service";
import { Head, BillItemContainer, ItemContainer, Separator, Footer } from "./styles";

const ModalBillToRoomConfirm = ({
  bill,
  selectedBookingId,
}) => {

  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [billArray, setBillArray] = useState(bill);

  const [chargeSuccessfullyIsOpen, setChargeSuccessfullyIsOpen] = useState(
    false
  );
  const [chargeFailedIsOpen, setChargeFailedIsOpen] = useState(false);
  const [billSuccessfullyIsOpen, setBillSuccessfullyIsOpen] = useState(false);
  const [billFailedIsOpen, setBillFailedIsOpen] = useState(false);

  const [createCharge, { loading }] = useMutation(CREATE_CHARGE);

  const handleAddCharge = () => {
    if (loading) return;

    createCharge({
      variables: {
        input: {
          billId: bill.billId,
          type: "EXTRA",
          amount: Number(bill.totalAmount),
          category: "FOOD_BEVERAGE",
          bookingId: selectedBookingId,
          description: "Bill to Room Charge",
        },
      },
    })
      .then((response) => {
        setChargeSuccessfullyIsOpen(true);
        setIsOpen(false);
      })
      .catch((error) => {
        setChargeFailedIsOpen(true);
        setIsOpen(false);
      });
  };

  const handleOnlyAddChargeToBill = () => {
    if (loading) return;
    createCharge({
      variables: {
        input: {
          billId: bill.billId,
          type: "EXTRA",
          amount: Number(bill.totalAmount),
          description: "Bill to Room Charge",
          category: "FOOD_BEVERAGE",
          bookingId: selectedBookingId,
          onlyAddChargeToBill: true,
        },
      },
    })
      .then((response) => {
        setBillSuccessfullyIsOpen(true);
        setChargeFailedIsOpen(false);
      })
      .catch((error) => {
        setBillFailedIsOpen(true);
        setChargeFailedIsOpen(false);
      });
  };

  const billList = useMemo(() => {
    const array = [];
    billArray.forEach((item) => {
      if (item.description === 'Tip') {
        array.push(
          <ItemContainer key={item.id}>
            <span className="description">{item.description}</span>
            <span className="value">${item.amount}</span>
          </ItemContainer>
        );
      }
    });
    array.push(
      <ItemContainer key="total">
        <span className="description">Tip</span>
        <Input
          inputFieldRef={inputRef}
          type="number"
          placeholder="Enter tip amount"
          value={billArray.tipAmount}
          onChange={(e) => setBillArray([...billArray, { description: 'Tip', amount: e.target.value }])}
          additionalstyle={`
            width: 120px;

            input {
              text-align: right;
            }
          `}
        />
      </ItemContainer>
    );
    array.push(
      <Separator />
    )
    array.push(
      <ItemContainer key="total" left>
        <span className="description">Total</span>
        <span className="value">${Number(billArray.find((item) => item.description === 'Tip').amount) + Number(billArray.find((item) => item.description === 'Subtotal').amount) || 0}</span>
      </ItemContainer>
    );
    return array;
  }, [billArray]);

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Bill to Room</Head>
        <BillItemContainer>
          {billList}
        </BillItemContainer>
        <Footer>
          <Button
            danger
            additionalstyle={`
              width: 79px;
            `}
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>
          <Button
            success
            additionalstyle={`
              width: 73px;
              margin-left: 16px;
            `}
            onClick={handleAddCharge}
            data-loading={loading}
          >
            {loading ? null : "Apply"}
          </Button>
        </Footer>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={chargeSuccessfullyIsOpen}
        setIsOpen={setChargeSuccessfullyIsOpen}
        amount={bill.totalAmount}
        cardNumber={bill.cardNumber}
        type="charge"
      />
      <ModalAddChargeFailed
        isOpen={chargeFailedIsOpen}
        setIsOpen={setChargeFailedIsOpen}
        amount={bill.totalAmount}
        balance={bill.balance}
        loading={loading}
        retryFunction={handleOnlyAddChargeToBill}
      />
      <ModalGeneralSuccessfully
        isOpen={billSuccessfullyIsOpen}
        setIsOpen={setBillSuccessfullyIsOpen}
        type="onlyAddChargeToBill"
      />
      <ModalGeneralFailed
        isOpen={billFailedIsOpen}
        setIsOpen={setBillFailedIsOpen}
        loading={loading}
        type="onlyAddChargeToBill"
      />
    </>
  );
};

export default ModalBillToRoomConfirm;
